import useCurrentStep from "@/hooks/use-current-step";
import useMeQuery from "@/hooks/use-me-query";
import usePermissions from "@/hooks/use-permissions";
import useWizardCanRedirect from "@/hooks/use-wizard-can-redirect";
import shouldNavigateToWizard from "@/utils/should-navigate-to-wizard";
import { FC, ReactNode } from "react";
import { Navigate, Outlet } from "react-router";

const ForceCompleteWizard: FC<{ children?: ReactNode }> = ({ children }) => {
  const { data } = useMeQuery();
  const currentStep = useCurrentStep();
  const { can } = usePermissions();
  const [canRedirect] = useWizardCanRedirect();
  const wizardNavigate = shouldNavigateToWizard(
    data,
    can("skip-wizard"),
    currentStep
  );

  if (!canRedirect || !wizardNavigate) {
    return children ?? <Outlet />;
  }

  return <Navigate to={wizardNavigate} replace />;
};

export default ForceCompleteWizard;
